var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"flex flex-col space-y-10 mt-6"},[_c('ProfileDetailCard'),_c('BasicInfoDetailCard'),_c('CurriculumnDetailCard'),_c('AddressDetailCard'),_c('ExperienceDetailCard'),_c('FormationDetailCard'),_c('LanguageDetailCard'),_c('SkillsDetailCard'),_c('PresentationDetailCard'),_c('ProfessionalProfileCard')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }